var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-404"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"bk_404"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("Oops~  您要找的页面已被雪藏"),_c('button',{on:{"click":_vm.back}},[_vm._v("返回首页")])])]),_vm._v(" "),_c('div',{staticClass:"bk2"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecc6deaa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/error/e404/index.vue
// module id = null
// module chunks = 